import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/qa-tools')({
  beforeLoad: authorizedRouteLoader('qaTools'),
  component: RouteComponent,
});

function RouteComponent() {
  return <Page links={[{ label: 'Dev Configs', to: '/qa-tools/dev-configs' }]} title="QA Tools" />;
}
